import React from 'react';
import {useTranslation} from 'react-i18next';

interface IConversationsSearchProps {
    searchString: string;
    setSearchString: (searchString: string) => void;
}

function ConversationsSearch({searchString, setSearchString}: IConversationsSearchProps): JSX.Element {
    const {t} = useTranslation();

    return (
        <div className="c-sidepanel__input">
            <input
                data-cy="messagingSearch"
                placeholder={t('messaging.search')}
                value={searchString}
                onChange={(e) => {
                    e.preventDefault();
                    setSearchString(e.target.value);
                }}
            />
        </div>
    );
}

export default ConversationsSearch;
